export enum FilterTypes {
	TEXT = 'TEXT',
	VERSION = 'VERSION',
	DATE = 'DATE',
	BOOLEAN = 'BOOLEAN',
	NUMBER = 'NUMBER',
	DURATION = 'DURATION',
	COUNTRY = 'COUNTRY',
	NONE = 'NONE',
}
